import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { getEstimatedViewportType } from "@faire/web--source/common/user-agent/getEstimatedViewportType";
import { ISearchBrandProductsFiltersRequest } from "@faire/web-api--source/indigofair/data/ISearchBrandProductsFiltersRequest";
import { ISearchProductsFromBrandRequest } from "@faire/web-api--source/indigofair/data/ISearchProductsFromBrandRequest";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { buildCategoryNavigationPath, getUrlIdsFromNavigationPath } from "../categories/navigationPath";
var DESKTOP_PAGE_SIZE = 60;
var MOBILE_PAGE_SIZE = 20;
export var returnRetrievalRankingDebugInfo = function(user, settingShouldDisplayRetrievalAndRankingDebugInfo) {
    if (!((user === null || user === void 0 ? void 0 : user.is_employee) || (user === null || user === void 0 ? void 0 : user.impersonating))) {
        return false;
    }
    return settingShouldDisplayRetrievalAndRankingDebugInfo;
};
export function loggedInBrandLeanProductTilesRequest(queryParams, clientSize, brandToken, user, settingShouldDisplayRetrievalAndRankingDebugInfo, forceDebugInfo, settingEnableUnlistedProductsRequests) {
    var _queryParams_filters;
    /**
   * when adding a brand query parameter that affects search
   * don't forget to pass them to and from the product page
   *
   * This preserves the same product search results in the brand page
   * when navigating from brand->product->brand
   *
   * to: retailer/views/brand/utils/generateProductUrlForBrandPage.ts
   * from: retailer/views/product/utils/generateBrandUrlForProductPage.ts
   * from: src/views/product/utils/generateProductUrlForProductPage.ts
   * - brand->product->product->brand
   */ return ISearchProductsFromBrandRequest.build({
        brand_token: brandToken,
        page_number: getPageNumber(queryParams),
        page_size: getPageSize(clientSize, queryParams, settingEnableUnlistedProductsRequests),
        include_sales_paused: true,
        query: queryParams.q,
        filter_keys: (_queryParams_filters = queryParams.filters) !== null && _queryParams_filters !== void 0 ? _queryParams_filters : [],
        client_size: clientSize,
        referrer: getReferrer(queryParams),
        ranking_boost: getRankingBoost(queryParams),
        return_retrieval_and_ranking_debug_info: forceDebugInfo ? true : returnRetrievalRankingDebugInfo(user, settingShouldDisplayRetrievalAndRankingDebugInfo !== null && settingShouldDisplayRetrievalAndRankingDebugInfo !== void 0 ? settingShouldDisplayRetrievalAndRankingDebugInfo : false)
    });
}
export function searchBrandProductsFiltersRequestFromProductTilesRequest(request) {
    // It is important that we don't do `{ ...request }` because cachingApi generates a cache key
    // from the request object. Any extra attributes may cause unnecessary cache misses.
    return ISearchBrandProductsFiltersRequest.build({
        brand_token: request.brand_token,
        query: request.query,
        filter_keys: request.filter_keys,
        client_size: request.client_size
    });
}
function getReferrer(queryParams) {
    var referrerRequestId = queryParams.refReqId, refType = queryParams.refType;
    var referrerType = ISearchRequestReferrer.SearchRequestReferrerType[refType !== null && refType !== void 0 ? refType : "NONE"];
    return ISearchRequestReferrer.build({
        referrer_type: referrerType !== null && referrerType !== void 0 ? referrerType : ISearchRequestReferrer.SearchRequestReferrerType.SEARCH_REQUEST_REFERRER_TYPE_UNKNOWN,
        referrer_request_id: referrerRequestId
    });
}
export function getPageNumber(queryParams) {
    var _queryParams_page;
    return (_queryParams_page = queryParams.page) !== null && _queryParams_page !== void 0 ? _queryParams_page : 1;
}
export function shouldShowUnlistedProducts(queryParams, settingEnableUnlistedProductsRequests) {
    var _queryParams_filters;
    var isInvalidFilter = queryParams === null || queryParams === void 0 ? void 0 : (_queryParams_filters = queryParams.filters) === null || _queryParams_filters === void 0 ? void 0 : _queryParams_filters.map(decodeURIComponent).some(function(filter) {
        return filter === "category:Sale" || filter === "category:New Arrivals" || filter === "category:Customizable";
    });
    return !!settingEnableUnlistedProductsRequests && !(queryParams === null || queryParams === void 0 ? void 0 : queryParams.collections) && !isInvalidFilter;
}
export function getPageSize(clientSize, queryParams, settingEnableUnlistedProductsRequests) {
    var shouldDisplayUnlistedProducts = shouldShowUnlistedProducts(queryParams, settingEnableUnlistedProductsRequests);
    if (shouldDisplayUnlistedProducts) {
        return clientSize === "DESKTOP" ? DESKTOP_PAGE_SIZE - 1 : MOBILE_PAGE_SIZE - 1;
    }
    return clientSize === "DESKTOP" ? DESKTOP_PAGE_SIZE : MOBILE_PAGE_SIZE;
}
function getRankingBoost(queryParams) {
    var _queryParams_refC;
    var _getUrlIdsFromNavigationPath = _to_array(getUrlIdsFromNavigationPath((_queryParams_refC = queryParams.refC) !== null && _queryParams_refC !== void 0 ? _queryParams_refC : "")), referrerCategory = _getUrlIdsFromNavigationPath[0], referrerSubCategories = _getUrlIdsFromNavigationPath.slice(1);
    return {
        should_use_sorting_hint: queryParams.sortingHint || undefined,
        referrer_category: referrerCategory ? referrerCategory : undefined,
        referrer_sub_category: referrerSubCategories.length > 0 ? buildCategoryNavigationPath(referrerSubCategories) : undefined,
        sort_by: queryParams.sortBy || undefined,
        selected_category: queryParams.cat || undefined,
        referrer_search: queryParams.refS || undefined,
        referrer_filters: queryParams.refF || [],
        referrer_products: queryParams.refP || []
    };
}
export function getEstimatedClientSize(estimatedViewport) {
    var type = (estimatedViewport !== null && estimatedViewport !== void 0 ? estimatedViewport : getEstimatedViewportType()).type;
    return type === "desktop" || type === "xLarge" ? "DESKTOP" : "MOBILE";
}
